module.exports = __webpack_public_path__ + "static/media/blue_plane.d76eadad.svg";